export default __webpack_public_path__ + "static/media/enterprise.c3683e28.svg";